(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("element-ui"), require("cb-components-common"), require("xlsx"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("cb-components-portfolio", ["element-ui", "cb-components-common", "xlsx", "vue"], factory);
	else if(typeof exports === 'object')
		exports["cb-components-portfolio"] = factory(require("element-ui"), require("cb-components-common"), require("xlsx"), require("vue"));
	else
		root["cb-components-portfolio"] = factory(root["ELEMENT"], root["cb-components-common"], root["XLSX"], root["Vue"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_element_ui__, __WEBPACK_EXTERNAL_MODULE_cb_components_common__, __WEBPACK_EXTERNAL_MODULE_xlsx__, __WEBPACK_EXTERNAL_MODULE_vue__) {
return 